import { useEffect, useState, useRef } from "react";

const useScripts = (urls) => {
  const [loaded, setLoaded] = useState(false);
  const [loadedScripts, setLoadedScripts] = useState([]);

  const initialized = useRef(false);

  const loadScript = (url) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = url;
      script.async = true;
      script.onload = () => {
        resolve(script);
      };
      script.onerror = () => {
        reject(script);
      };
      document.body.appendChild(script);
      console.log("script loaded: ", url);
    });
  };

  useEffect(() => {
    const loadScripts = async () => {
      for (let i = 0; i < urls.length; i++) {
        try {
          const script = await loadScript(urls[i]);
          setLoadedScripts((loadedScripts) => [...loadedScripts, script]);
        } catch (e) {
          console.log("error", e);
        }
      }
    };

    if (initialized.current === false) {
      initialized.current = true;
      loadScripts().then(() => {
        setLoaded(true);
      });
    }
  }, [urls]);

  useEffect(() => {
    return () => {
      // remove all scripts
      loadedScripts.forEach((script) => {
        document.body.contains(script) && document.body.removeChild(script);
      });
    };
  }, [loadedScripts]);

  return loaded;
};

export default useScripts;
